export default "__VITE_ASSET__f467b3fc__"